// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KL6G","tabsBox":"styles_tabsBox__100eq","createButton":"styles_createButton__2ZYvh"};